import React from 'react';

const STEPS = [
  {
    idx: '01',
    title: 'Learns your normal',
    body: 'Every shower is a little different. Goldie learns yours — when you shower, how long you take, how you move.',
  },
  {
    idx: '02',
    title: 'Checks in when it changes',
    body: 'Running longer than usual? Gone still? Goldie asks out loud, right in the stall, before involving anyone else.',
  },
  {
    idx: '03',
    title: 'Escalates only if needed',
    body: 'No answer, and Goldie safely stops the water and notifies the people who care about you.',
  },
];

function PredictiveAlgorithm() {
  return (
    <section className="pt-[80px] md:pt-[100px] pb-[80px]" id="predict">
      <div className="max-w-[1180px] mx-auto px-6 md:px-8">
        <div className="max-w-[640px] mb-14">
          <div className="inline-flex items-center gap-2 text-[0.78rem] font-semibold tracking-[0.08em] uppercase text-navy">
            <span className="w-[7px] h-[7px] rounded-full bg-sky animate-nu-pulse-ring motion-reduce:animate-none" />
            The Care Check Loop
          </div>
          <h2 className="font-display text-[2rem] md:text-[2.4rem] font-bold text-navy-deep my-3.5 mb-4">
            Goldie doesn&apos;t guess. It learns your routine — and responds when it changes.
          </h2>
          <p className="text-[1.05rem] text-navy leading-[1.65]">
            Goldie builds a baseline for your normal shower — timing, duration, movement. When
            your routine shifts, Goldie responds: a voice check-in first, and it only escalates
            if there&apos;s no answer.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="bg-cream shadow-nu-out rounded-nu p-9 relative overflow-hidden">
            <div className="relative w-full h-[280px] md:h-[320px] flex items-center justify-center">
              <div className="relative w-[220px] h-[220px] md:w-[260px] md:h-[260px] rounded-full shadow-nu-radar-inset flex items-center justify-center">
                <div className="absolute w-[70%] h-[70%] rounded-full border border-navy/[0.18]" />
                <div className="absolute w-[45%] h-[45%] rounded-full border border-navy/[0.18]" />
                <div className="absolute w-[22%] h-[22%] rounded-full border border-navy/[0.18]" />
                <div
                  className="absolute w-1/2 h-0.5 top-1/2 left-1/2 origin-left rounded-sm bg-gradient-to-r from-sky/90 to-sky/0 animate-nu-sweep motion-reduce:animate-none"
                  aria-hidden="true"
                />
                <div
                  className="absolute w-3.5 h-3.5 rounded-full bg-amber animate-nu-alertpulse motion-reduce:animate-none"
                  style={{ top: '34%', left: '64%' }}
                  aria-hidden="true"
                />
              </div>
              <div className="absolute bottom-3.5 left-0 right-0 text-center text-[0.82rem] text-navy font-medium">
                Live radar sweep · deviation noticed
              </div>
            </div>
          </div>

          <div className="flex flex-col">
            {STEPS.map((step, i) => (
              <div
                key={step.idx}
                className={`flex gap-5 py-[22px] ${
                  i !== STEPS.length - 1 ? 'border-b border-navy/10' : ''
                }`}
              >
                <div className="flex-none w-11 h-11 rounded-full flex items-center justify-center bg-cream shadow-nu-idx font-display font-bold text-[0.95rem] text-navy-deep">
                  {step.idx}
                </div>
                <div>
                  <h3 className="text-[1.08rem] font-semibold text-navy-deep mb-1.5">{step.title}</h3>
                  <p className="text-[0.94rem] text-navy leading-[1.55] m-0">{step.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PredictiveAlgorithm;
